module.exports = __webpack_public_path__ + "img/img_2.ee7e511e.png";